import React from 'react';

import styles from "../styles/betting-promotion.module.scss"
import classNames from "classnames";
import {BETTING_PROMOTION} from "../bettin-ptomotion.module.consts";
import {Link} from "../../../../../core/components/link/link";
import {useBookieClick} from "../../../../../infrastructure/hooks/useBookieClick";
import {BettingPromotionClickAnalyticsEvent} from "../models/betting-promotion.click-analytics.event";
import {LINK_REL} from "../../../../../core/consts";

export const BettingPromotionModuleButton = ({controller, button}) => {
  const {state} = controller;
  const {style, label, shouldOpenLink, type} = button;

  const onButtonClick = () => controller.action(BETTING_PROMOTION.ACTION_TYPES.onPopupClick, {type, shouldOpenLink});

  const {bookieHrefModel, onBookieClick} = useBookieClick(controller, {
    version: state.version,
    timesShown: state.popupVisibleCounter,
    clickType: type,
    urlLink: state.bookie.bookieLinkUrl,
    bookieLinkUrl: state.bookie.bookieLinkUrl,
    textType: state.type,
    bookieId: state.bookie.id,
    imageUrl: state.imageUrl,
    mainText: state.bookie.titleText.aliasName,
    secondaryTextTerm: state.bookie.ctaText.aliasName,
  }, true, BettingPromotionClickAnalyticsEvent)

  const buttonProps = {
    style,
    className: classNames(styles.button),
    onClick: () => onButtonClick && onButtonClick()
  };

  const linkProps = {
    style,
    className: classNames(styles.button),
    rel: LINK_REL.SPONSORED_NOOPENER,
    model: shouldOpenLink ? bookieHrefModel : null,

    onClick: () => {
      onButtonClick()

      return shouldOpenLink && onBookieClick()
    }
  }

  return type === BETTING_PROMOTION.CLICK_TYPE.link ? <Link {...linkProps}>{label}</Link>:
    <div {...buttonProps}>{label}</div>;
};
